/* eslint-disable react-hooks/rules-of-hooks */
import { useFirestore as useReactFireFirestore } from 'reactfire'

const useFirestore = () => {
  return typeof window !== 'undefined' && useReactFireFirestore()
}

export default useFirestore
